// extracted by mini-css-extract-plugin
export default {"footerWrapper":"modalFooter_footerWrapper__EXfEi"};